import { useMutation } from "@tanstack/vue-query";
import axios from "axios";
import {
  UsersApi,
  type UsersPasswordResetPostRequest,
  type UsersPasswordResetTokenPostRequest,
} from "mws-identity-ts-sdk";

let usersApi: UsersApi;

const getUsersApi = () => {
  // reduce memory overhead by only using one instance
  if (!usersApi) {
    usersApi = new UsersApi(
      undefined,
      useRuntimeConfig().public.identityServiceUrl,
      axios,
    );
  }

  return usersApi;
};

export const useResetPasswordEmailMutation = () => {
  const nuxtApp = useNuxtApp();

  return useMutation({
    mutationFn: async (
      usersPasswordResetTokenPostRequest: UsersPasswordResetTokenPostRequest,
    ) => {
      if (nuxtApp.$amplify) {
        await nuxtApp.$amplify.auth.resetPassword({
          username: usersPasswordResetTokenPostRequest.email.toLowerCase(),
        });
      }
    },
  });
};

export const useResetPasswordMutation = () => {
  const nuxtApp = useNuxtApp();

  return useMutation({
    mutationFn: async (
      usersPasswordResetPostRequest: UsersPasswordResetPostRequest & {
        username: string;
      },
    ) => {
      if (nuxtApp.$amplify) {
        if (
          !usersPasswordResetPostRequest.username ||
          !usersPasswordResetPostRequest.passwordResetToken
        ) {
          throw new Error("Missing username or passwordResetToken");
        }

        await nuxtApp.$amplify.auth.confirmResetPassword({
          username: usersPasswordResetPostRequest.username,
          newPassword: usersPasswordResetPostRequest.newPassword,
          confirmationCode: usersPasswordResetPostRequest.passwordResetToken,
        });
      }
    },
  });
};

export const useSetPaymentVerificationToPendingMutation = () =>
  useMutation({
    mutationFn: () => getUsersApi().usersVerificationPaymentPendingPut(),
  });
